import React, { useEffect } from "react";
import './Healing_Banner.css'
import { AllGetSpandan_Banner } from '../../../features/admin/spandan/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../../utils/IDS";
const Healing_Banner = () => {

  const dispatch = useDispatch();

  const all_spandan_banner = useSelector((state) => state.spandan.all_spandan_banner);


  useEffect(() => {
    dispatch(AllGetSpandan_Banner());
  }, [dispatch]);

  return (
    <section className='Healing_Banner'>
      <div className='container'>
        <div className='banner_holder'>
          <img src={`${IDS.IMG_URL + all_spandan_banner[0]?.image}`} className='banner_img' />
        </div>
      </div>
    </section>
  )
}

export default Healing_Banner
